<template>
    <div class="log-auditoria-container">
      <div class="page-header">
        <h1 class="text-h4 font-weight-bold text-orange-darken-1">
          <v-icon class="mr-2">mdi-file-document-outline</v-icon>
          Log de Auditoria
        </h1>
        <p class="text-subtitle-1 text-grey-darken-1">
          Histórico completo de ações administrativas do sistema
        </p>
      </div>
  
      <v-card>
        <v-card-text class="pa-6">
          <div class="text-center py-8">
            <v-avatar size="80" color="orange-lighten-3" class="mb-4">
              <v-icon size="40" color="orange-darken-1">mdi-file-document-outline</v-icon>
            </v-avatar>
            <h3 class="text-h6 text-grey mb-2">Log de Auditoria</h3>
            <p class="text-grey">Esta funcionalidade será implementada em breve</p>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LogAuditoria'
  }
  </script>
  
  <style scoped>
  .log-auditoria-container {
    padding: 24px;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    min-height: 100vh;
  }
  
  .page-header {
    margin-bottom: 24px;
  }
  </style>